import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { useEffect } from 'react';
import { useNavigate, useRoutes } from 'react-router-dom';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import MinimalRoutes from './MinimalRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const Routes = () => {
    const navigate = useNavigate();

    const location = useSelector<AppState, any>(
        (state) => state.router.location,
        (left, right) => JSON.stringify(left) === JSON.stringify(right)
    );

    const url = location.pathname.substring(0, 9);
    const isCallbackUrl = url === '/callback';

    useEffect(() => {
        if (isCallbackUrl) {
            navigate('/callback', { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCallbackUrl]);

    return useRoutes([LoginRoutes, AuthenticationRoutes, MinimalRoutes, MainRoutes]);
};

export default Routes;
